import React from 'react'

export default function TitleSection({title, subtitle,  reversed=false}) {
    return (
        <div className="titleSection">

            {!reversed? 
            <>
                     <h1 className="title">{title}</h1>
            <h2 className="subtitle">{subtitle} </h2>
             </> :  <>
            <h2 className="subtitle">{subtitle} </h2>
                     <h1 className="title">{title}</h1>
             </>}
        </div>
    )
}
